<template>
  <div  class="m-footer-layout-comment" v-if="show" @touchmove.stop.prevent @click="hide">
    <sq-comment></sq-comment>
  </div>
</template>

<script>
import Comment from './comment'
export default {
  components: {
    'sq-comment': Comment
  },
  computed: {
    show () {
      return this.$store.state.comment.show
    }
  },
  methods: {
    hide () {
      this.$store.dispatch('hideCommentArea')
      this.$store.dispatch('blurbottom')
    }
  }
}
</script>



// WEBPACK FOOTER //
// commentArea.vue?141db990